package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Team(
    @SerialName("_id") var _id: String? = null,
    @SerialName("name") var name: String? = null,
    @SerialName("workspaceId") var workspaceId: String? = null,
    @SerialName("employees") var employees: List<User>? = emptyList(),
    @SerialName("type") var type: String? = null,
    @SerialName("createdAt") var createdAt: Long? = null,
    @SerialName("updatedAt") var updatedAt: Long? = null,
) {
    fun isDifferent(other: Team): Boolean {
        val differences = mutableListOf<String>()

        if (this._id != other._id) differences.add("_id: '${this._id}' vs '${other._id}'")
        if (this.name != other.name) differences.add("name: '${this.name}' vs '${other.name}'")
        if (this.workspaceId != other.workspaceId) differences.add("workspaceId: '${this.workspaceId}' vs '${other.workspaceId}'")
        if (this.type != other.type) differences.add("type: '${this.type}' vs '${other.type}'")
        if (this.createdAt != other.createdAt) differences.add("createdAt: '${this.createdAt}' vs '${other.createdAt}'")
        if (this.updatedAt != other.updatedAt) differences.add("updatedAt: '${this.updatedAt}' vs '${other.updatedAt}'")

        // Compare employees lists by comparing each element
        val employeesChanged = when {
            this.employees == null && other.employees != null -> true
            this.employees != null && other.employees == null -> true
            this.employees?.size != other.employees?.size -> true
            else -> {
                this.employees?.zip(other.employees ?: emptyList())
                    ?.any { (thisEmployee, otherEmployee) ->
                        thisEmployee.isDifferent(otherEmployee)
                    } ?: false
            }
        }

        if (employeesChanged) differences.add("employees: different elements found")

        if (differences.isNotEmpty()) {
            println("Team differences found for team '${this.name}' (${this._id}):")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}
